module.exports = __webpack_public_path__ + "img/emoji_75.13c8ba24.png";